import { Box, TextField } from "@mui/material";
import { useState } from "react";
import { FieldValues, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { updateProfile } from "../clients/FixieApiClient";
import { LoadingButton } from "@mui/lab";
import DashboardPage from "../layouts/DashboardPage";

export default () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data: FieldValues) => {
    setIsLoading(true);
    const response = await updateProfile(data);
    if (response.ok) {
      toast.success("Your password has been updated");
      navigate("/apps");
    }
    setIsLoading(false);
  };


  return (
    <DashboardPage title="Please choose a new password">
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <Box sx={{ padding: '1rem' }}>
          <TextField {...register('newPassword')} required fullWidth margin="dense" label="New Password" type="password" variant="outlined" />
          <LoadingButton
            loading={isLoading}
            disableElevation
            variant="contained"
            type="submit"
            fullWidth
            sx={{ mt: 2, mb: 2, height: "56px" }}
          >
            <span>Submit</span>
          </LoadingButton>
        </Box>
      </Box >
    </DashboardPage >
  )
}
